import React, {Fragment} from 'react'
import Slider from 'react-slick';
import { SLICK_BREAKPOINT_KEY } from '../../constants/slickBreakpoints';

const feedbackContent = [
    {
        title: '"실제 운영까지 책임지는 파트너"',
        desc: 'CODAM과 함께한 ERP 연동 플랫폼 구축은 납품 완료 후에도 지속적인 기술 지원이 이루어졌습니다. 개발팀의 전문성과 비즈니스 이해도가 높아 원하는 방향으로 시스템이 완성되었습니다.',
        img: 'author-4b',
        author: '이현석',
        desig: '㈜스마트팩토리 개발본부장',
    },
    {
        title: '"AI 시스템 구축의 신뢰할 수 있는 파트너"',
        desc: 'AI 기반 문서 자동화 시스템 도입 이후 팀의 반복 업무가 크게 줄었습니다. CODAM 팀은 기술적 전문성뿐 아니라 실제 업무 프로세스를 깊이 이해하고 있어 도입이 수월했습니다.',
        img: 'author-5b',
        author: '최지현',
        desig: '한국핀테크솔루션 데이터팀장',
    },
    {
        title: '"클라우드 전환, 안심하고 맡길 수 있었습니다"',
        desc: '레거시 시스템을 클라우드로 전환하는 과정에서 무중단 마이그레이션을 성공적으로 완료했습니다. 보안 강화와 성능 최적화까지 함께 이루어져 만족도가 매우 높습니다.',
        img: 'author-4b',
        author: '박민규',
        desig: '유통그룹 IT 전략팀 과장',
    },
    {
        title: '"기업 환경을 깊이 이해하는 개발팀"',
        desc: '복잡한 요구사항과 기존 시스템 연동이 필요한 프로젝트였음에도 CODAM 팀은 체계적으로 접근하여 일정 내 완료했습니다. 유지보수 계약도 자연스럽게 이어졌습니다.',
        img: 'author-5b',
        author: '김도훈',
        desig: '제조전문기업 IT 팀장',
    },
];

const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    padding:15,
    [SLICK_BREAKPOINT_KEY]: [
        { breakpoint: 991, settings: { slidesToShow: 1 } }
    ]
};

const FeedbackTwo = () => {
    return (
        <Fragment>
            <Slider {...settings} className="row gx-0 feedback-slider-two">
                {feedbackContent.map((val,i)=>(
                    <div key={i} className="col-lg-6">
                        <div className="feedback-style-two">
                            <h4>{val.title}</h4>
                            <p>{val.desc}</p>
                            <div className="author d-flex align-items-center mt-35">
                                <img src={`assets/img/testimonial/${val.img}.jpg`} alt={`${val.author} 프로필`}/>
                                <div className="author-info">
                                    <h5>{val.author}</h5>
                                    <span>{val.desig}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </Fragment>
    )
}

export default FeedbackTwo
